import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installRuntimeGuards } from "@/lib/runtimeGuards";
import { registerServiceWorker } from "@/lib/registerSW";

installRuntimeGuards();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
